import { DOCUMENT } from '@angular/common';
import { Component, OnInit,HostListener, Inject  } from '@angular/core';
@Component({
  selector: 'app-premium',
  templateUrl: './premium.component.html',
  styleUrls: ['./premium.component.scss']
})
export class PremiumComponent implements OnInit {

  toTop : boolean = false;

  constructor(@Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
  }

  @HostListener("window:scroll", [])
onWindowScroll() {
  if ( window.scrollY > 280) {
    this.toTop = true;
  }else{
    this.toTop = false;
  }
 }

}
